<template>
  <div>
    <b-overlay :show="saving">
      <b-card>
        <b-button
          variant="primary"
          @click="goToUpsert('new')"
        >
          <feather-icon icon="PlusCircleIcon" />
          {{ $t('projects.new') }}
        </b-button>
      </b-card>
      <b-card no-body>
        <b-table
          striped
          hover
          responsive
          class="position-relative"
          :items="readItems"
          :fields="fields"
        >
          <!-- Removed PDF links: list now shows basic metadata only -->
          <template #cell(createdAt)="data">
            <span>{{ new Date(data.item.createdAt).toLocaleString() }}</span>
          </template>
          <template #cell(updatedAt)="data">
            <span>{{ new Date(data.item.updatedAt).toLocaleString() }}</span>
          </template>
          <template #cell(projectPdfUri)="data">
            <a
              :href="data && data.item ? data.item.projectPdfUri : ''"
              target="_blank"
            >
              Projeto PDF
            </a>
          </template>
          <template #cell(projectPdfUriT)="data">
            <a
              :href="data && data.item ? data.item.projectPdfUriT : ''"
              target="_blank"
            >
              Projeto PDF Transposto
            </a>
          </template>
          <template #cell(projectPdfUriL)="data">
            <a
              :href="data && data.item ? data.item.projectPdfUriL : ''"
              target="_blank"
            >
              Projeto PDF Paisagem
            </a>
          </template>
          <template #cell(duplicate)="data">
            <b-link @click="duplicate(data)">
              <feather-icon
                icon="CopyIcon"
                class="mr-50"
                size="20"
              />
            </b-link>
          </template>
          <template #cell(action)="data">
            <b-link @click="goToUpsert(data.item.id)">
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="20"
              />
            </b-link>
          </template>
          <template #cell(delete)="data">
            <b-link @click="deleteModal(data.item.id)">
              <feather-icon
                icon="TrashIcon"
                class="mr-50"
                size="20"
              />
            </b-link>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BLink,
  BCard,
  BTable,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BLink,
    BCard,
    BTable,
    BButton,
    BOverlay,
  },
  data() { return { items: [], inputs: [], saving: false } },
  computed: {
    readItems() { return this.items },
    fields() {
      return [
        { key: 'acelerador', label: 'Acelerador', sortable: true },
        { key: 'modelo', label: 'Modelo', sortable: true },
        { key: 'pointsCount', label: 'Pontos', sortable: true },
        { key: 'projectPdfUri', label: 'Projeto', sortable: true },
        { key: 'projectPdfUriT', label: 'Projeto PDF Transposto', sortable: true },
        { key: 'projectPdfUriL', label: 'Projeto PDF Paisagem', sortable: true },
        { key: 'createdAt', label: 'Data de Criação', sortable: true },
        { key: 'updatedAt', label: 'Data de Atualização', sortable: true },
        { key: 'duplicate', label: 'Duplicar', sortable: false },
        { key: 'action', label: 'Editar', sortable: false },
        { key: 'delete', label: 'Remover', sortable: false },
      ]
    },
  },
  async created() { await this.load() },
  methods: {
    goToUpsert(id) {
      if (!id || id === 'new') {
        this.$router.push({ name: 'pages-radio-create' })
      } else {
        this.$router.push({ name: 'pages-radio-upsert', params: { id } })
      }
    },
    async load() {
      let raw = await this.$store.dispatch('radio/index')
      // parse input/output if they are strings and build a normalized array
      raw = raw.map(it => ({
        id: it.id,
        output: it.output && typeof it.output === 'string' ? JSON.parse(it.output) : it.output,
        input: it.input && typeof it.input === 'string' ? JSON.parse(it.input) : it.input,
        createdAt: it.createdAt,
        updatedAt: it.updatedAt,
      }))
      // keep all entries (don't require a successful output) and extract the desired fields
      this.items = raw.map(e => ({
        id: e.id,
        createdAt: e.createdAt,
        updatedAt: e.updatedAt,
        acelerador: e.input && e.input.data && e.input.data.ident ? e.input.data.ident.acelerador : '',
        modelo: e.input && e.input.data && e.input.data.ident ? e.input.data.ident.modelo : '',
        pointsCount: e.input && e.input.data && Array.isArray(e.input.data.points) ? e.input.data.points.length : 0,
        projectPdfUri: e.output && e.output.links ? `${process.env.VUE_APP_API_URL}files/${e.output.links.projectPdfUri}` : 'Erro ao gerar PDF',
        projectPdfUriT: e.output && e.output.links ? `${process.env.VUE_APP_API_URL}files/${e.output.links.projectPdfUriT}` : 'Erro ao gerar PDF Transposto',
        projectPdfUriL: e.output && e.output.links ? `${process.env.VUE_APP_API_URL}files/${e.output.links.projectPdfUriL}` : 'Erro ao gerar PDF Paisagem',
      }))
      this.inputs = raw.map(e => ({ id: e.id, input: e.input }))
    },
    async deleteModal(id) {
      this.$swal({
        ...this.$t('calcBlindage.toast.deleteReport'),
        buttonsStyling: false,
        showDenyButton: true,
        customClass: { confirmButton: 'btn btn-danger mr-1', denyButton: 'btn btn-primary' },
      }).then((result => {
        if (!result.isConfirmed) { return }
        this.$store.dispatch('radio/delete', id).then(() => { this.load() })
      }))
      await this.load()
    },
    async duplicate(data) {
      this.$swal({
        title: 'Você tem certeza?',
        text: 'O relatório será duplicado e você não poderá reverter esta operação.',
        confirmButtonText: 'Sim, duplicar',
        denyButtonText: 'Cancelar',
        buttonsStyling: false,
        showDenyButton: true,
        customClass: { denyButton: 'btn btn-danger mr-1', confirmButton: 'btn btn-primary' },
      }).then((result => {
        if (result.isConfirmed) {
          const form = this.inputs.find(e => e.id === data.item.id).input.data
          // console.log('Duplicando relatório:', form)
          this.createData(form)
        }
      }))
    },
    async createData(payload) {
      this.saving = true
      try {
        await this.$store.dispatch(
          'project/generateRadioReport',
          { payload },
        )
        await this.load()
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            ...this.$t('projectUpsertForm.upsertdErrorToast'),
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      } finally { this.saving = false }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@media (max-width: 767px){
  .small-devices-filterby{
    display: block;
  }
}
.dropdown button {
    padding: 0px;
}
.em-dropdown .dropdown-menu {
  max-height: 100px;
  overflow-y: hidden;
}
.dropdown-item{
  padding: 0 4px;
}
</style>
